export default __webpack_public_path__ + "static/media/downloadIcon.88928624.svg";